// The maintenance family's payload accessors — a LEAF module, deliberately:
// `maintenance.ts` composes `MAINTENANCE_TENANCY` (from `./maintenance-tenancy`) into
// its own table, and `maintenance-tenancy.ts` needs these same helpers, so they used
// to live IN `maintenance.ts` and `maintenance-tenancy.ts` imported them from there —
// a cycle. Entering the module graph at `maintenance-tenancy.ts` ran `maintenance.ts`'s
// body first (for the helpers), which hit the spread of `MAINTENANCE_TENANCY` before
// that binding initialized: `ReferenceError: Cannot access 'MAINTENANCE_TENANCY' before
// initialization`. Reproduced before this file existed. This file imports nothing from
// either family module, so neither can cycle through it.

/** A payload as a plain object, or null — never assumed, always checked. */
export function rec(v: unknown): Record<string, unknown> | null {
  return typeof v === 'object' && v !== null ? (v as Record<string, unknown>) : null;
}

/** A payload's string field, or null — absent, wrong-typed and withheld all read the same. */
export function str(v: unknown, key: string): string | null {
  const r = rec(v);
  if (r === null) return null;
  const val = r[key];
  return typeof val === 'string' ? val : null;
}

/** A payload's number field, or null. */
export function num(v: unknown, key: string): number | null {
  const r = rec(v);
  if (r === null) return null;
  const val = r[key];
  return typeof val === 'number' ? val : null;
}
